<template>
  <div>
    <LuJhu lu-jhu-type="DanShuangLuJhu" />
  </div>
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'DanShuang',
  components: {
    LuJhu
  }
}
</script>

